import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Container, Row, Col } from "react-bootstrap";
import PageHeader from "../../../components/page-header/PageHeader";
import AnnouncementCardAdmin from "./components/AnnouncementCard.tsx/AnnouncementCardAdmin";
import Pagination from "../../../../../shared/components/ui/pagination/Pagination";
import {
  Announcement,
  useAnnouncements,
} from "../../../../../contexts/announcement-context/AnnouncementContext";
import FormValidator from "../../../../../shared/utils/FormValidator";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import SelectCountry from "../../../../../shared/components/countrySelectorModal/SelectCountry";
import { useHistory } from "react-router-dom";
import { DashboardAnnouncementsPages } from "../AnnouncementRoutes";
import emptyAnnouncementImage from "../../../../../shared/resources/announcement-empty.png";
import { useGlobelFilterContext } from "../../../../../contexts/globel-filter-context/GlobelFilterContext";

const initialPagination = {
  total_pages: 0,
  page_number: 0,
};

interface Filter {
  date: Date | undefined;
  keyword: string;
  status: "active" | "inactive" | "default";
  country: MCountry;
}

enum MCountry {
  SELECT_COUNTRY = "",
  ALL = "ALL",
  MALAYSIA = "MALAYSIA",
  SRI_LANKA = "SRI_LANKA",
  BOSNIA = "BOSNIA",
  JAMAICA = "JAMAICA",
  INDIA = "INDIA",
  INDONESIA = "INDONESIA",
}

const initialFilters: Filter = {
  date: undefined,
  keyword: "",
  status: "default",
  country: MCountry.SELECT_COUNTRY,
};

const ITEM_COUNT_IN_PAGE: number = 2;
const AnnouncementsAdmin = () => {
  const { announcements: allAnnouncements, haveNoties } = useAnnouncements();
  // const [filters, setFilters] = useState(initialFilters);
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [pagination, setPagination] = useState(initialPagination);
  const [modalCountrySelectorShow, setModalCountrySelectorShow] = useState(
    false
  );

  const {
    announcementFiltersAdmin: announcementFilters,
    setAnnouncementFiltersAdmin: setAnnouncementFilters,
  } = useGlobelFilterContext();

  const appUser = useAppUser();

  useEffect(() => {
    if (!appUser.userRole.isAdmin)
      setAnnouncementFilters({
        ...announcementFilters,
        country: appUser.country as any,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUser.country, appUser.userRole]);

  useEffect(() => {
    setPagination((ps) => {
      return { ...ps, page_number: 0 };
    });
  }, [
    announcementFilters.date,
    announcementFilters.country,
    announcementFilters.keyword,
    announcementFilters.status,
  ]);

  const { push } = useHistory();

  useEffect(() => {
    if (announcements.length % ITEM_COUNT_IN_PAGE === 0) {
      const totalPages = announcements.length / ITEM_COUNT_IN_PAGE;
      setPagination((ps) => ({ ...ps, total_pages: totalPages }));
    } else {
      const totalPages =
        Math.floor(announcements.length / ITEM_COUNT_IN_PAGE) + 1;
      setPagination((ps) => ({ ...ps, total_pages: totalPages }));
    }
  }, [announcements]);

  const paginate = (
    array: Announcement[],
    page_number: number,
    page_size: number
  ): Announcement[] =>
    array.slice(page_number * page_size, (page_number + 1) * page_size);

  useEffect(() => {
    let f_announcements = allAnnouncements;

    f_announcements.sort((a, b) => b.date.seconds - a.date.seconds);

    if (announcementFilters.date) {
      f_announcements = f_announcements.filter((announcement) => {
        if (announcement.date && announcementFilters.date) {
          return FormValidator.areDatesEqual(
            announcement.date.toDate(),
            announcementFilters.date
          );
        } else {
          return true;
        }
      });
    }

    if (announcementFilters.keyword) {
      f_announcements = f_announcements.filter((announcement) => {
        if (announcement.description && announcementFilters.keyword) {
          return announcement.description
            .replace(/<[^>]+>/g, "")
            .replace(/&nbsp;/g, "")
            .includes(announcementFilters.keyword);
        } else {
          return true;
        }
      });
    }

    if (announcementFilters.status !== "default") {
      f_announcements = f_announcements.filter(
        (a) => a.isActive === (announcementFilters.status === "active")
      );
    }

    if (
      announcementFilters.country !== MCountry.SELECT_COUNTRY &&
      announcementFilters.country !== MCountry.ALL
    ) {
      f_announcements = f_announcements.filter((announcement) => {
        if (announcement.countries.length !== 0) {
          return announcement.countries.includes(
            announcementFilters.country as any
          );
        } else {
          return true;
        }
      });
    }

    setAnnouncements(f_announcements);
  }, [
    announcementFilters.date,
    announcementFilters.status,
    announcementFilters.keyword,
    allAnnouncements,
    announcementFilters.country,
  ]);

  useEffect(() => {
    console.log("mounted");

    return () => {
      console.log("un-mounted");
    };
  }, []);

  return (
    <div className="create-sr-wrapper">
      <PageHeader title="Notices" />
      {haveNoties ? (
        <Container
          fluid
          style={{
            paddingTop: "225px",
            paddingLeft: "50px",
            paddingRight: "50px",
            paddingBottom: "50px",
          }}
        >
          <Row>
            <Col
              xs={12}
              md={3}
              xl={3}
              className="d-flex align-items-center ml-md-0 my-1 my-md-0"
            >
              <div style={{ flex: "1" }}>
                <input
                  className="app-input  search-img"
                  style={{ paddingRight: "50px" }}
                  placeholder="Search by keyword"
                  value={announcementFilters.keyword}
                  onChange={(e) => {
                    setAnnouncementFilters({
                      ...announcementFilters,
                      keyword: e.target.value,
                    });
                  }}
                />
              </div>
            </Col>
            <Col
              xs={12}
              md={3}
              xl={3}
              className="d-flex align-items-center ml-md-0 my-1 my-md-0"
            >
              <div style={{ flex: "1" }}>
                <DatePicker
                  className="app-input  calender-img"
                  selected={announcementFilters.date}
                  onChange={(date: Date) => {
                    setAnnouncementFilters({ ...announcementFilters, date });
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                  placeholderText={"DD/MM/YYYY"}
                  popperClassName={"customDatePicker"}
                  customInput={<input className="app-input-profile" />}
                />
              </div>
            </Col>
            {appUser.userRole.isAdmin && (
              <Col
                xs={12}
                md={4}
                xl={4}
                className="d-flex justify-content-end my-1 my-md-0"
              >
                <div style={{ flex: "1" }}>
                  <select
                    className="app-input filter-img"
                    value={announcementFilters.country}
                    onChange={(e) => {
                      setAnnouncementFilters({
                        ...announcementFilters,
                        country: e.target.value as any,
                      });
                    }}
                  >
                    <option value="" disabled hidden>
                      Country
                    </option>
                    <option value="ALL">All Countries</option>
                    <option value="MALAYSIA">Malaysia</option>
                    <option value="SRI_LANKA">Sri Lanka</option>
                    <option value="BOSNIA">Bosnia and Herzegovina</option>
                    <option value="JAMAICA">Jamaica</option>
                    <option value="INDIA">India</option>
                    <option value="INDONESIA">Indonesia</option>
                  </select>
                </div>
              </Col>
            )}
            <Col
              xs={12}
              md={2}
              xl={2}
              className="d-flex align-items-center my-1 my-md-0"
            >
              <div style={{ flex: "1" }}>
                <select
                  className="app-input   filter-img"
                  value={announcementFilters.status}
                  onChange={(e) => {
                    setAnnouncementFilters({
                      ...announcementFilters,
                      status: e.target.value as any,
                    });
                  }}
                >
                  <option value="default" disabled hidden>
                    Status
                  </option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={12} className="d-flex align-items-end my-1 my-md-0">
              <div style={{ flex: "1" }} className="text-right">
                <button
                  className="app-button"
                  style={{
                    backgroundColor: "#6c757d",
                    padding: "3px 10px 3px 10px",
                  }}
                  onClick={() => setAnnouncementFilters(initialFilters)}
                >
                  Clear filters
                </button>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={12}>
              {paginate(
                announcements,
                pagination.page_number,
                ITEM_COUNT_IN_PAGE
              ).map((a, index) => (
                <AnnouncementCardAdmin i={index} key={index} announcement={a} />
              ))}
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xs={12}>
              <Col xs={12}>
                <Pagination
                  pInfo={{
                    page: pagination.page_number,
                    totalPages: pagination.total_pages,
                  }}
                  onPageChanged={(page) => {
                    setPagination({ ...pagination, page_number: page });
                  }}
                />
              </Col>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container
          fluid
          style={{
            paddingTop: "200px",
            paddingLeft: "50px",
            paddingRight: "50px",
            paddingBottom: "50px",
          }}
        >
          <Col
            className="text-center"
            style={{
              marginTop: "100px",
              color: "grey",
            }}
          >
            <div style={{ fontSize: "200px" }}>
              <img
                style={{ width: "150px" }}
                src={emptyAnnouncementImage}
                alt=""
              />
            </div>
            <h2 className="mt-3">There are no notices to display</h2>
            <button
              style={{
                marginRight: "0px",
                marginTop: "30px",
              }}
              onClick={() =>
                push(DashboardAnnouncementsPages.CREATE_ANNOUNCEMENT)
              }
              className="body-create-workshop-button pr-4"
            >
              Create an announcement
            </button>
          </Col>
        </Container>
      )}
      {appUser.userRole.isAdmin && (
        <SelectCountry
          show={modalCountrySelectorShow}
          onHide={() => {
            setModalCountrySelectorShow(false);
          }}
        />
      )}
    </div>
  );
};

export default AnnouncementsAdmin;
